// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts
export const MobileAppFlavorConfigAreaId = 'mobile-app-flavor-config' as const
